import React, { useContext, useEffect, useState } from "react";
import { Button } from "../../../../../stories/Button/Button";
import { Title } from "../../../../../stories/Title/Title";
import {
  empType,
  ItmsChallasEnum,
  LicenseTypes,
  Operation,
  PageFor,
  PageFrom,
  TableHeaders,
} from "../../../../../utils/Enum.types";
import Navbar from "../../../../common/layout/Navbar";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleMUISelectEvent,
  startEndDates,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import {
  AddModalStyles,
  ViewAssetStyles,
} from "../../../../../styles/CustomModalStyles";
import AddDailyEntry from "./AddItmsChallanPage";
import { useLazyQuery } from "@apollo/client";
import {
  ExportItmsChallansResult,
  ExportItmsChallansVariables,
  GetItmsChallansResult,
  GetItmsChallansTotalCountResult,
  GetItmsChallansTotalCountVar,
  GetItmsChallansVars,
  ItmsChallansEdge,
  ItmsChallansOrderField,
  ItmsChallanType,
  OrderDirection,
} from "./queries/types";
import {
  ExportItmsChallans,
  GetItmsChallans,
  GetItmsChallansTotalCount,
} from "./queries/queries";
import {
  EMPTY_STRING,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import Edit from "../../../../../images/EditProfile.svg";
import NoData from "../../../../../images/NoData.svg";
import { payloadTypes } from "../../../../../context/reducer";
import { AppContext } from "../../../../../context/context";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { useNavigate } from "react-router-dom";
import {
  GridAlignment,
  GridCellParams,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import { TextField } from "@mui/material";
import dayjs from "dayjs";
import Compare from "../../../../../images/Compare.svg";
import LoadingModal from "../../../../pages/LoadingModal";
import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import MessageModal from "../../../../../customComponents/MessageModal";
import { getDownloadUrl } from "../../../../../utils/DownloadFile";
import ImportItmsChallans from "./ImportItmsChallans";
import Close from "../../../../../images/Close.svg";

export interface FilterFormDataType {
  endDate: string;
  fromDate: string;
}

interface Props {
  NavType: LicenseTypes;
  pageForm?: PageFrom;
  setModalFlag?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ItmsChallan = ({ NavType, pageForm, setModalFlag }: Props) => {
  const { Masters_Table } = useAssetTableJson();
  const navigate = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const { customer_id } = useUrlParams();
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [subsidiries, setSubsidiries] = useState<ItmsChallansEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [addModal, setAddModal] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [editModal, setEditModal] = useState(false);
  const { serverDate } = useServerDateandTime();
  const [challanType, setChallanType] = useState("");
  const [message, setMessage] = useState(emptyMessage);
  const [importModal, setImportModal] = useState(false);

  const { startDate: initialStartDate, endDate: initialEndDate } =
    startEndDates(1);
  const [filterFormData, setFilterFormData] = useState<FilterFormDataType>({
    endDate: initialEndDate,
    fromDate: initialStartDate,
  });

  const dynamicHeaders: TableHeaderProps[] = Masters_Table.ItmsChallan.map(
    (header) => ({
      headerName: header.headerName,
      cellClassName: header.cellClassName as string,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex as number,
      hideable: header.hideable,
    }),
  );
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      cellClassName: "td-status ",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        const today = toStandardDate(serverDate);
        const yesterday = toStandardDate(
          dayjs(serverDate).subtract(1, "day").toString(),
        );

        const isValid =
          params.row.date === today || params.row.date === yesterday;
        if (isValid) {
          return (
            <>
              <img
                src={Edit}
                alt=""
                onClick={() => {
                  dispatch({
                    type: payloadTypes.SET_ITEMS_CHALLAN_ID,
                    payload: {
                      ItmsChallanId: params.row.itmsChallanId,
                    },
                  });
                  setEditModal(true);
                }}
              />
            </>
          );
        }
      },
    },
  ];

  const [Export, { loading: exportLoading }] = useLazyQuery<
    ExportItmsChallansResult,
    ExportItmsChallansVariables
  >(ExportItmsChallans, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [getItmsChallans, { data, loading, fetchMore }] = useLazyQuery<
    GetItmsChallansResult,
    GetItmsChallansVars
  >(GetItmsChallans);

  const [
    getItmsChallansTotalCount,
    { data: GetTotalCount, loading: GetCountLoading },
  ] = useLazyQuery<
    GetItmsChallansTotalCountResult,
    GetItmsChallansTotalCountVar
  >(GetItmsChallansTotalCount);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItmsChallans.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = subsidiries.find(
            (sub) => sub.node.id === newCompany.node.id,
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setSubsidiries(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            itmsChallanId: node.id,
            date: toStandardDate(node.date),
            stopLine: node.stopLine,
            seatBelt: node.seatBelt,
            jumpingSignal: node.jumpingSignal,
            tripleRide: node.tripleRide,
            noHelmet: node.noHelmet,
            overSpeed: node.overSpeed,
            driverOnCall: node.driverOnCall,
            total: node.total,
            challanType: node.challanType,
          })),
        );
      } else {
        setSubsidiries(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            itmsChallanId: node.id,
            date: toStandardDate(node.date),
            stopLine: node.stopLine,
            seatBelt: node.seatBelt,
            jumpingSignal: node.jumpingSignal,
            tripleRide: node.tripleRide,
            noHelmet: node.noHelmet,
            overSpeed: node.overSpeed,
            driverOnCall: node.driverOnCall,
            total: node.total,
            challanType: node.challanType,
          })),
        );
      }
      setEndCursor(data.GetItmsChallans.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetItmsChallans.edges;
          const pageInfo = fetchMoreResult.GetItmsChallans.pageInfo;
          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetItmsChallans.edges.filter(
            ({ node: { id } }) =>
              newEdges.findIndex(({ node: { id: newId } }) => newId === id) !==
              -1,
          );

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetItmsChallans: {
              edges: [...subsidiries, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetItmsChallans.totalCount! : 0,
            },
          };
        },
      });
    }
  };

  useEffect(() => {
    if (customer_id)
      getItmsChallans({
        variables: {
          after: null,
          customer_id: customer_id ? customer_id : 0,
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: ItmsChallansOrderField.DATE,
          },
          startDate: filterFormData.fromDate
            ? toIsoDate(filterFormData.fromDate)
            : undefined,
          endDate: filterFormData.endDate
            ? toIsoDate(filterFormData.endDate)
            : undefined,
          name: searchData,
          challanTypeIn: challanType
            ? [challanType as ItmsChallanType]
            : [ItmsChallanType.BIAL, ItmsChallanType.ITMS],
        },
      });
  }, [
    customer_id,
    getItmsChallans,
    searchData,
    filterFormData.fromDate,
    filterFormData.endDate,
    challanType,
  ]);

  useEffect(() => {
    if (filterFormData.fromDate && filterFormData.endDate && customer_id)
      getItmsChallansTotalCount({
        variables: {
          customer_id,
          endDate: toIsoDate(filterFormData.endDate),
          startDate: toIsoDate(filterFormData.fromDate),
        },
      });
  }, [
    getItmsChallansTotalCount,
    filterFormData.fromDate,
    filterFormData.endDate,
    customer_id,
  ]);

  const getRow = () => {
    const summery = GetTotalCount && GetTotalCount.GetItmsChallansTotalCount;
    if (rows.length) {
      return [
        {
          id: "",
          date: "",
          stopLine: summery?.stopLine,
          seatBelt: summery?.seatBelt,
          jumpingSignal: summery?.jumpingSignal,
          tripleRide: summery?.tripleRide,
          noHelmet: summery?.noHelmet,
          overSpeed: summery?.overSpeed,
          driverOnCall: summery?.driverOnCall,
          total: summery?.total,
        },
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow(),
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "stopLine":
        case "seatBelt":
        case "jumpingSignal":
        case "tripleRide":
        case "noHelmet":
        case "overSpeed":
        case "driverOnCall":
        case "total":
          return "total-count";
        default:
          return "hide-td";
      }
    }

    return "";
  };

  const commonAutocompleteProps = {
    className: labelClasses.inputRoot,
    options: Object.values(ItmsChallasEnum),
    // openOnFocus: true,
  };

  const commonTextFieldProps = {
    label: "Challan Type",
    fullWidth: true,
    className: labelClasses.formControlRoot,
  };

  const handleExport = async () => {
    if (customer_id) {
      Export({
        variables: {
          customer_id,
          startDate: filterFormData.fromDate
            ? toIsoDate(filterFormData.fromDate)
            : undefined,
          endDate: filterFormData.endDate
            ? toIsoDate(filterFormData.endDate)
            : undefined,
          challanType: challanType
            ? (challanType as ItmsChallanType)
            : undefined,
        },
      }).then(async ({ data }) => {
        if (data && data.ExportItmsChallans) {
          const res = await getDownloadUrl(data.ExportItmsChallans, true);
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        }
      });
    }
  };

  const handleClose = () => {
    setMessage(emptyMessage);
  };

  return (
    <>
      {pageForm === PageFrom.MODAL ? (
        <>
          <img
            src={Close}
            alt=""
            className="modal-close-icon"
            onClick={() => setModalFlag?.(false)}
          />
        </>
      ) : (
        <>
          {" "}
          {pageForm === PageFrom.DASHBOARD ? null : (
            <Navbar NavType={NavType} />
          )}
        </>
      )}
      <Title>ITMS Challan</Title>
      <div
        className={`itms-challan${pageForm === PageFrom.MODAL ? "--modal" : ""}`}
      >
        <div className="row g-0 itms-challan__select">
          <div className="col-2">
            <LabeledAutocomplete
              {...commonAutocompleteProps}
              value={challanType}
              isOptionEqualToValue={(option) =>
                (option as string) === challanType ||
                challanType === EMPTY_STRING
              }
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  handleMUISelectEvent(e);
                }
              }}
              onChange={(
                e: React.SyntheticEvent<Element, Event>,
                value: unknown,
              ) => {
                if (value) {
                  setChallanType(value as string);
                } else {
                  setChallanType("");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...commonTextFieldProps}
                  autoFocus={true}
                  autoComplete="one-time-code"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                />
              )}
            />
          </div>
          <div className="col"></div>
          <div className="col-5 flex-end">
            <TextField
              label="From date"
              className="asset-reports__right--textfield"
              slotProps={{
                inputLabel: { shrink: true },
                input: {
                  inputProps: {
                    max: toInputStandardDate(serverDate),
                  },
                },
              }}
              type="date"
              onChange={(e) => {
                if (
                  dayjs(e.target.value).isAfter(dayjs(filterFormData.endDate))
                ) {
                  return;
                }
                setFilterFormData({
                  ...filterFormData,
                  fromDate: e.target.value,
                });
              }}
              value={filterFormData.fromDate}
            />

            <img src={Compare} alt="" />
            <TextField
              label="To date"
              className="asset-reports__right--textfield"
              slotProps={{
                inputLabel: { shrink: true },
                input: {
                  inputProps: {
                    max: toInputStandardDate(serverDate),
                  },
                },
              }}
              type="date"
              onChange={(e) => {
                if (
                  dayjs(e.target.value).isBefore(dayjs(filterFormData.fromDate))
                ) {
                  return;
                }
                setFilterFormData({
                  ...filterFormData,
                  endDate: e.target.value,
                });
              }}
              value={filterFormData.endDate}
            />
            {pageForm === PageFrom.DASHBOARD ? null : (
              <Button
                mode="addnew"
                onClick={() => {
                  setAddModal(true);
                }}
              />
            )}
          </div>
        </div>
        <div
          className={
            pageForm === PageFrom.DASHBOARD
              ? "d-challans__tableblock"
              : "itms-challan__tableblock"
          }
        >
          {rows.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              disableRowSelectionOnClick
              hideFooter
              pinnedRows={pinnedRows}
              getCellClassName={getCellClassName}
              onRowsScrollEnd={handleScroll}
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        {pageForm === PageFrom.DASHBOARD ? null : (
          <div className="row g-0">
            <div className="col">
              {state.empSubType === empType.SYS_ADMIN ||
              state.empSubType === empType.DATABASE_ADMIN ? (
                <Button mode="excel" onClick={() => setImportModal(true)}>
                  Import
                </Button>
              ) : null}

              <Button mode="export" onClick={() => handleExport()} />
              {pageForm === PageFrom.MODAL ? (
                <>
                  <Button mode="cancel" onClick={() => setModalFlag?.(false)} />
                </>
              ) : (
                <>
                  <Button mode="back" onClick={() => navigate(-1)} />
                </>
              )}
            </div>
            <div className="col-2 flex-end">
              <div className="overall-total-count">
                Total Count : <b>{data?.GetItmsChallans.totalCount}</b>
              </div>
            </div>
          </div>
        )}
      </div>

      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        contentComponent={
          <AddDailyEntry
            setModalFlag={setEditModal}
            operation={Operation.UPDATE}
            filterFormData={filterFormData}
          />
        }
        style={ViewAssetStyles}
      />

      <CustomModal
        isOpen={addModal}
        onRequestClose={() => setAddModal(!addModal)}
        contentComponent={
          <AddDailyEntry
            setModalFlag={setAddModal}
            operation={Operation.CREATE}
            filterFormData={filterFormData}
          />
        }
        style={ViewAssetStyles}
      />

      <CustomModal
        isOpen={importModal}
        onRequestClose={() => setImportModal(!importModal)}
        contentComponent={
          <ImportItmsChallans
            setModalFlag={setImportModal}
            pageType={PageFor.MODAL}
            NavType={LicenseTypes.COMPANY}
          />
        }
        style={AddModalStyles}
      />

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={loading || GetCountLoading} />
    </>
  );
};

export default ItmsChallan;
